module.exports = __webpack_public_path__ + "img/beli-paket.c8ff9477.svg";